import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { TypesenseService } from 'src/app/shared/services/typesense.service';
import { FirebaseRemoteConfigService } from 'src/app/shared/services/firebase-remote-config.service';

@Component({
    selector: 'app-stock-recommendation',
    templateUrl: './stock-recommendation.component.html',
    styleUrls: ['./stock-recommendation.component.scss'],
    standalone: false
})
export class StockRecommendationComponent implements OnInit, OnChanges {
   private subscriptions: Subscription[];
   public _recommendation: any | undefined;
   public maxRecommendationName: string = '';
   public recommendationColor: string = '';
   recommendationCount: any = '';
   @Input() showLabel: boolean = false;
   @Input() stockname: string = '';
   @Input() ticker: string = '';
   @Input() stockComplianceRating: string = '';
   loading: boolean = true;
   guageChartData: any;
   guageValue!: any;
   analystRatingDisclaimer: string = '';

   constructor(
      private typesenseService: TypesenseService,
      private configService: FirebaseRemoteConfigService
   ) {
      this.subscriptions = [];
   }

   ngOnInit(): void {
      this.setData();
      this.getDisclaimer();
   }

   setData() {
      this.loading = true;

      if (this.ticker) {
         this.typesenseService
            .getRecommendation(this.ticker)
            .then((data: any) => {
               this.recommendationCount =
                  data.strongBuy +
                  data.buy +
                  data.hold +
                  data.sell +
                  data.strongSell;
               let weightedSum = 5 * data.strongBuy;
               weightedSum += 4 * data.buy;
               weightedSum += 3 * data.hold;
               weightedSum += 2 * data.sell;
               weightedSum += 1 * data.strongSell;

               const dataArr = [
                  data.strongBuy,
                  data.buy,
                  data.hold,
                  data.sell,
                  data.strongSell,
               ];

               var totalPercent = 0;
               var largestIndex = -1;
               let percentArr: any = [];
               dataArr.forEach((element, index) => {
                  var percent = Math.round(
                     (element / this.recommendationCount) * 100
                  );
                  totalPercent += percent;
                  percentArr.push(percent);
                  if (index == 0) {
                     largestIndex = 0;
                  } else {
                     if (percent > percentArr[largestIndex]) {
                        largestIndex = index;
                     }
                  }
               });

               if (totalPercent > 100) {
                  percentArr[largestIndex] = percentArr[largestIndex] - 1;
               } else if (totalPercent < 100) {
                  percentArr[largestIndex] = percentArr[largestIndex] + 1;
               }

               const weightedAverage = weightedSum / this.recommendationCount;
               if (weightedAverage < 1.5) {
                  this.maxRecommendationName = 'Strong sell';
                  this.recommendationColor = '#C70707';
                  this.guageValue = 0;
               }

               if (weightedAverage >= 1.5 && weightedAverage < 2.5) {
                  this.maxRecommendationName = 'SELL';
                  this.recommendationColor = '#FA6C6C';
                  this.guageValue = 45;
               }

               if (weightedAverage >= 2.5 && weightedAverage < 3.5) {
                  this.maxRecommendationName = 'HOLD';
                  this.recommendationColor = '#212121';
                  this.guageValue = 90;
               }

               if (weightedAverage >= 3.5 && weightedAverage < 4.5) {
                  this.maxRecommendationName = 'BUY';
                  this.recommendationColor = '#80C780';
                  this.guageValue = 135;
               }

               if (weightedAverage >= 4.5) {
                  this.maxRecommendationName = 'Strong buy';
                  this.recommendationColor = '#39a939';
                  this.guageValue = 180;
               }

               // this.guageValue = (weightedAverage*180)/5;

               this._recommendation = data;
               this._recommendation.strongBuy = percentArr[0];
               this._recommendation.buy = percentArr[1];
               this._recommendation.hold = percentArr[2];
               this._recommendation.sell = percentArr[3];
               this._recommendation.strongSell = percentArr[4];

               this.loading = false;
            })
            .catch((error: any) => {
               this.loading = false;
            });
      }
   }

   ngOnChanges(changes: any) {
      this.setData();
   }

   async getDisclaimer() {
      let config = await this.configService.getConfigDefault();
      this.analystRatingDisclaimer = config?.analyst_rating_disclaimer;
   }
}
